import React, { useState, useCallback, useRef, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTiktok,
  faLinkedinIn,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
import {
  faSpinner,
  faLayerGroup,
  faSearch,
  faTimesCircle,
  faChevronRight,
  faChevronDown,
  faBullhorn,
  faPause,
  faPlay,
  faCalendarAlt,
  faSort,
  faSortUp,
  faSortDown,
  faImage,
  faRectangleAd,
  faFileArrowDown,
  faCircleCheck,
  faXmark,
  faPencil,
  faCheck,
  faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { getRequest, postRequest } from "services/api/apiService";
import { toast } from "react-toastify";

// ─── Demo Data (shown when platform is not connected) ────────────

const DEMO_DATA = {
  campaigns: {
    tiktok: [
      { id: "DEMO_TIK_001", name: "Summer Sale 2025 — App Installs",   status: "ENABLE",  objective: "APP_PROMOTION", budgetValue: 150, isDailyBudget: true  },
      { id: "DEMO_TIK_002", name: "Brand Awareness — Morocco",          status: "ENABLE",  objective: "REACH",         budgetValue: 80,  isDailyBudget: true  },
      { id: "DEMO_TIK_003", name: "Retargeting — Website Visitors",     status: "DISABLE", objective: "TRAFFIC",       budgetValue: 200, isDailyBudget: false },
    ],
    meta: [
      { id: "DEMO_META_001", name: "Lead Gen — Morocco Q2",             status: "ACTIVE",  objective: "LEAD_GENERATION", budgetValue: 50,  isDailyBudget: true  },
      { id: "DEMO_META_002", name: "Retargeting — Website Visitors",    status: "ACTIVE",  objective: "CONVERSIONS",     budgetValue: 80,  isDailyBudget: true  },
      { id: "DEMO_META_003", name: "Cold Audience — Lookalike 2%",      status: "PAUSED",  objective: "CONVERSIONS",     budgetValue: 300, isDailyBudget: false },
    ],
    linkedin: [
      { id: "DEMO_LI_001", name: "B2B Lead Gen — Decision Makers",      status: "ACTIVE",  budgetValue: 0 },
      { id: "DEMO_LI_002", name: "Brand Awareness — Tech Sector",        status: "PAUSED",  budgetValue: 0 },
    ],
    snapchat: [
      { id: "DEMO_SNAP_001", name: "Story Ads — Gen Z Audience",         status: "ACTIVE",  budgetValue: 50,  isDailyBudget: true  },
      { id: "DEMO_SNAP_002", name: "AR Lens — Product Launch",           status: "PAUSED",  budgetValue: 200, isDailyBudget: false },
    ],
  },
  adGroups: {
    tiktok: {
      DEMO_TIK_001: [
        { id: "DEMO_TIK_AG_001", name: "18–34 Males — Interest Targeting",   status: "ENABLE"  },
        { id: "DEMO_TIK_AG_002", name: "Lookalike Purchasers — LAL 2%",      status: "DISABLE" },
      ],
      DEMO_TIK_002: [
        { id: "DEMO_TIK_AG_003", name: "Morocco — All Genders 18+",          status: "ENABLE"  },
      ],
      DEMO_TIK_003: [],
    },
    meta: {
      DEMO_META_001: [
        { id: "DEMO_META_AG_001", name: "Morocco — Business Owner Interests", status: "ACTIVE" },
        { id: "DEMO_META_AG_002", name: "Morocco — LAL 2% Customers",        status: "ACTIVE" },
      ],
      DEMO_META_002: [
        { id: "DEMO_META_AG_003", name: "Website Visitors — Last 30 Days",   status: "ACTIVE" },
      ],
      DEMO_META_003: [],
    },
    linkedin: {
      DEMO_LI_001: [
        { id: "DEMO_LI_AG_001", name: "Decision Makers — Sponsored InMail",     status: "ACTIVE" },
        { id: "DEMO_LI_AG_002", name: "Decision Makers — Sponsored Content",    status: "PAUSED" },
      ],
      DEMO_LI_002: [],
    },
    snapchat: {
      DEMO_SNAP_001: [
        { id: "DEMO_SNAP_AG_001", name: "18–24 — Snap Stories Placement",      status: "ACTIVE" },
      ],
      DEMO_SNAP_002: [],
    },
  },
  ads: {
    tiktok: {
      DEMO_TIK_AG_001: [
        { id: "DEMO_TIK_AD_001", name: "Creative A — Product Video 15s",   status: "ACTIVE", format: "SINGLE_VIDEO", thumbnailUrl: null },
        { id: "DEMO_TIK_AD_002", name: "Creative B — UGC Unboxing 30s",    status: "ACTIVE", format: "SINGLE_VIDEO", thumbnailUrl: null },
      ],
      DEMO_TIK_AG_002: [
        { id: "DEMO_TIK_AD_003", name: "Creative C — Customer Testimonial", status: "ACTIVE", format: "SINGLE_VIDEO", thumbnailUrl: null },
      ],
      DEMO_TIK_AG_003: [
        { id: "DEMO_TIK_AD_004", name: "Brand Video — Morocco 30s",         status: "ACTIVE", format: "SINGLE_VIDEO", thumbnailUrl: null },
      ],
    },
    meta: {
      DEMO_META_AG_001: [
        { id: "DEMO_META_AD_001", name: "Lead Form Ad — Version A",          status: "ACTIVE", thumbnailUrl: null },
        { id: "DEMO_META_AD_002", name: "Lead Form Ad — Version B",          status: "ACTIVE", thumbnailUrl: null },
      ],
      DEMO_META_AG_002: [
        { id: "DEMO_META_AD_003", name: "Carousel — Top Products",           status: "ACTIVE", thumbnailUrl: null },
      ],
      DEMO_META_AG_003: [
        { id: "DEMO_META_AD_004", name: "Dynamic Retargeting — Catalog",     status: "ACTIVE", thumbnailUrl: null },
      ],
    },
    linkedin: {
      DEMO_LI_AG_001: [
        { id: "DEMO_LI_AD_001", name: "InMail — Free Trial Offer",           status: "ACTIVE", thumbnailUrl: null },
      ],
      DEMO_LI_AG_002: [
        { id: "DEMO_LI_AD_002", name: "Sponsored Content — Case Study",      status: "PAUSED", thumbnailUrl: null },
      ],
    },
    snapchat: {
      DEMO_SNAP_AG_001: [
        { id: "DEMO_SNAP_AD_001", name: "Story Ad — Summer Collection",      status: "ACTIVE", type: "SNAP_AD", thumbnailUrl: null },
        { id: "DEMO_SNAP_AD_002", name: "Story Ad — Promo Offer",            status: "ACTIVE", type: "SNAP_AD", thumbnailUrl: null },
      ],
    },
  },
  insights: {
    tiktok: {
      DEMO_TIK_001: { spend: "892.40",  impressions: "234500", clicks: "8920", ctr: "3.80" },
      DEMO_TIK_002: { spend: "410.80",  impressions: "512000", clicks: "2048", ctr: "0.40" },
      DEMO_TIK_003: { spend: "0.00",    impressions: "0",      clicks: "0",    ctr: "0.00" },
    },
    meta: {
      DEMO_META_001: { spend: "312.40", impressions: "89200",  clicks: "2680", ctr: "3.00" },
      DEMO_META_002: { spend: "498.60", impressions: "45100",  clicks: "1804", ctr: "4.00" },
      DEMO_META_003: { spend: "0.00",   impressions: "0",      clicks: "0",    ctr: "0.00" },
    },
  },
};

// ─── Constants ───────────────────────────────────────────────────

const PLATFORMS = [
  { key: "tiktok",   label: "TikTok",    icon: faTiktok,     iconColor: "text-black" },
  { key: "meta",     label: "Meta",      icon: faFacebookF,  iconColor: "text-blue-600" },
  { key: "linkedin", label: "LinkedIn",  icon: faLinkedinIn, iconColor: "text-blue-700" },
  { key: "snapchat", label: "Snapchat",  emoji: "👻" },
  { key: "google",   label: "Google",    icon: faGoogle,     iconColor: "text-red-500" },
];

const DATE_PRESETS = [
  { key: "alltime", label: "All Time" },
  { key: "today",   label: "Today" },
  { key: "7d",      label: "7 days" },
  { key: "30d",     label: "30 days" },
];

const STATUS_FILTERS = ["ALL", "ACTIVE", "PAUSED"];
const STATUS_FILTER_LABEL = { ALL: "Toutes", ACTIVE: "Actives", PAUSED: "En pause" };

// Sélecteur de compte publicitaire par plateforme (liste + compte courant +
// sauvegarde). Permet de basculer de compte directement dans Campaigns, avec
// auto-sélection par défaut pour éviter le « aucun compte sélectionné ».
const ACCOUNT_UI = {
  google: {
    fetchList: async (getRequest) => {
      const r = await getRequest("/api/ads/google/fetch-accessible-ads-accounts");
      return (r?.data || []).map(a => ({
        id: String(a.id),
        label: a.descriptiveName ? `${a.descriptiveName} · ${a.id}` : a.id,
        disabled: !!a.isManager, // un compte gestionnaire (MCC) ne diffuse pas
      }));
    },
    current: async (getRequest) => {
      const r = await getRequest("/api/ads/google/fetch-google-ads-account");
      return r?.data?.google_ads_id ? String(r.data.google_ads_id) : null;
    },
    ensureDefault: async (postRequest) => {
      const r = await postRequest("/api/ads/google/ensure-default-account", {});
      return r?.google_ads_id ? String(r.google_ads_id) : null;
    },
    save: (postRequest, id) => postRequest("/api/ads/google/save-google-ads-account", { googleAdsId: id }),
  },
  tiktok: {
    // Comptes récupérés VIA L'API TikTok (/oauth2/advertiser/get/), pas la BD.
    fetchList: async (getRequest) => {
      const r = await getRequest("/api/ads/tiktok/fetch-advertisers");
      return (r?.data || []).map(a => ({
        id: String(a.id),
        label: a.name && a.name !== a.id ? `${a.name} · ${a.id}` : String(a.id),
        disabled: false,
      }));
    },
    current: async (getRequest) => {
      const r = await getRequest("/api/ads/tiktok/fetch-tiktok-ads-account");
      return r?.data?.tiktok_ads_advertiser_id ? String(r.data.tiktok_ads_advertiser_id) : null;
    },
    ensureDefault: async (postRequest) => {
      const r = await postRequest("/api/ads/tiktok/ensure-default-account", {});
      return r?.tiktok_ads_advertiser_id ? String(r.tiktok_ads_advertiser_id) : null;
    },
    save: (postRequest, id) => postRequest("/api/ads/tiktok/save-tiktok-ads-account", { tiktoksAdvertisorId: id }),
  },
  meta: {
    fetchList: async (getRequest) => {
      const r = await getRequest("/api/ads/meta/fetch-available-ad-account-ids");
      return (r?.data || []).map(a => ({
        id: String(a.adAccountId),
        label: a.name ? `${a.name} · ${a.adAccountId}` : String(a.adAccountId),
        disabled: Number(a.status) !== 1, // status 1 = ACTIVE ; les autres non diffusables
        businessId: a.businessId || null,
      }));
    },
    current: async (getRequest) => {
      const r = await getRequest("/api/ads/meta/fetch-meta-ads-account");
      const d = r?.data;
      return (d?.meta_ads_account_id || d) ? String(d.meta_ads_account_id || d) : null;
    },
    ensureDefault: async (postRequest) => {
      const r = await postRequest("/api/ads/meta/ensure-default-account", {});
      return r?.meta_ads_account_id ? String(r.meta_ads_account_id) : null;
    },
    save: (postRequest, id) => postRequest("/api/ads/meta/save-meta-ads-account", { metaAdsAccountId: id }),
  },
  snapchat: {
    fetchList: async (getRequest) => {
      const r = await getRequest("/api/ads/snapchat/fetch-available-ad-accounts");
      return (r?.data || []).map(a => ({
        id: String(a.id),
        label: a.name ? `${a.name} · ${a.id}` : String(a.id),
        disabled: false,
      }));
    },
    current: async (getRequest) => {
      const r = await getRequest("/api/ads/snapchat/fetch-snapchat-ads-account");
      const d = r?.data;
      return d?.snapchat_ads_advertiser_id ? String(d.snapchat_ads_advertiser_id) : (d ? String(d) : null);
    },
    ensureDefault: async (postRequest) => {
      const r = await postRequest("/api/ads/snapchat/ensure-default-account", {});
      return r?.snapchat_ads_advertiser_id ? String(r.snapchat_ads_advertiser_id) : null;
    },
    save: (postRequest, id) => postRequest("/api/ads/snapchat/save-snapchat-ads-account", { snapchatAdvertiserId: id }),
  },
  linkedin: {
    fetchList: async (getRequest) => {
      const r = await getRequest("/api/ads/linkedin/ad-accounts");
      return (r?.data?.accounts || []).map(a => ({
        id: String(a.id),
        label: a.name && a.name !== "Unknown" ? `${a.name} · ${a.id}` : String(a.id),
        disabled: false,
      }));
    },
    current: async (getRequest) => {
      const r = await getRequest("/api/ads/linkedin/ad-accounts");
      return r?.data?.selectedLinkedInAdvertiserId ? String(r.data.selectedLinkedInAdvertiserId) : null;
    },
    ensureDefault: async (postRequest) => {
      const r = await postRequest("/api/ads/linkedin/ensure-default-account", {});
      return r?.linkedin_ads_advertiser_id ? String(r.linkedin_ads_advertiser_id) : null;
    },
    save: (postRequest, id) => postRequest("/api/ads/linkedin/save-linkedin-ads-account", { linkedinAdvertiserId: id }),
  },
};

const STATUS_CLASSES = {
  ACTIVE:    "bg-green-100 text-green-700 border border-green-200",
  ENABLE:    "bg-green-100 text-green-700 border border-green-200",
  PAUSED:    "bg-amber-100 text-amber-700 border border-amber-200",
  DISABLE:   "bg-amber-100 text-amber-700 border border-amber-200",
  CANCELLED: "bg-red-100 text-red-600 border border-red-200",
  DELETED:   "bg-gray-100 text-gray-500 border border-gray-200",
  ARCHIVED:  "bg-gray-100 text-gray-500 border border-gray-200",
};

// ─── Small Components ─────────────────────────────────────────────

const StatusBadge = ({ status }) => {
  // Libellé normalisé : toute variante active → ACTIVE, en pause → PAUSED,
  // le reste garde son nom (DRAFT, ARCHIVED…). Couleur par catégorie.
  const cat = statusCategory(status);
  const cls =
    cat === "active" ? "bg-green-100 text-green-700 border border-green-200" :
    cat === "paused" ? "bg-amber-100 text-amber-700 border border-amber-200" :
    (STATUS_CLASSES[String(status || "").toUpperCase()] || "bg-gray-100 text-gray-400 border border-gray-200");
  const label = cat === "active" ? "ACTIVE" : cat === "paused" ? "PAUSED" : (String(status || "").toUpperCase() || "UNKNOWN");
  return (
    <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold ${cls}`}>
      {label}
    </span>
  );
};

// isCurrent=false : absent du dernier sync réussi (batch, toutes les 5 min) —
// supprimé/archivé côté régie, ou compte déconnecté. Conservé en BD comme
// historique plutôt que supprimé, mais visuellement distingué du temps réel.
const HistoryBadge = () => (
  <span
    title="Absent du dernier sync — dernière valeur connue conservée en historique"
    className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-gray-100 text-gray-500 border border-gray-200"
  >
    History
  </span>
);

const MetricCell = ({ value, loading }) =>
  loading
    ? <span className="inline-block w-10 h-3 rounded bg-gray-200 animate-pulse" />
    : <span className="text-xs text-gray-600">{value}</span>;

const SummaryStat = ({ label, value, color = "text-gray-800", loading = false }) => (
  <div className="flex flex-col min-w-[60px]">
    <span className="text-[10px] text-gray-400 uppercase tracking-wide font-semibold">{label}</span>
    {loading
      ? <span className="mt-0.5 inline-block w-12 h-4 rounded bg-gray-200 animate-pulse" />
      : <span className={`text-sm font-bold ${color}`}>{value}</span>
    }
  </div>
);

const SearchInput = ({ value, onChange, placeholder, light = false }) => (
  <div className="relative">
    <FontAwesomeIcon
      icon={faSearch}
      className={`absolute left-2.5 top-1/2 -translate-y-1/2 text-xs pointer-events-none ${light ? "text-gray-400" : "text-white/60"}`}
    />
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={e => onChange(e.target.value)}
      className={`pl-7 pr-7 py-1.5 text-xs rounded-lg focus:outline-none w-40 ${
        light
          ? "border border-gray-200 focus:ring-2 focus:ring-[#221C51]/20"
          : "bg-white/10 border border-white/20 text-white placeholder-white/40 focus:bg-white/20"
      }`}
    />
    {value && (
      <FontAwesomeIcon
        icon={faTimesCircle}
        className={`absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-xs ${light ? "text-gray-400" : "text-white/60"}`}
        onClick={() => onChange("")}
      />
    )}
  </div>
);

const SortableHeader = ({ label, sortKey, sortConfig, onSort, className = "" }) => {
  const isAct = sortConfig.key === sortKey;
  return (
    <th className={`px-4 py-3 font-medium cursor-pointer select-none group ${className}`} onClick={() => onSort(sortKey)}>
      <span className="flex items-center gap-1">
        {label}
        <FontAwesomeIcon
          icon={isAct ? (sortConfig.dir === "asc" ? faSortUp : faSortDown) : faSort}
          className={`text-[10px] transition-colors ${isAct ? "text-white" : "text-white/30 group-hover:text-white/60"}`}
        />
      </span>
    </th>
  );
};

const SortableHeaderLight = ({ label, sortKey, sortConfig, onSort, className = "" }) => {
  const isAct = sortConfig.key === sortKey;
  return (
    <th className={`px-4 py-3 font-medium cursor-pointer select-none group ${className}`} onClick={() => onSort(sortKey)}>
      <span className="flex items-center gap-1">
        {label}
        <FontAwesomeIcon
          icon={isAct ? (sortConfig.dir === "asc" ? faSortUp : faSortDown) : faSort}
          className={`text-[10px] transition-colors ${isAct ? "text-[#221C51]" : "text-gray-300 group-hover:text-gray-400"}`}
        />
      </span>
    </th>
  );
};

// mediaType="video" : certaines régies (Snapchat) ne fournissent aucune image de
// couverture séparée pour une vidéo — l'URL renvoyée EST le fichier vidéo. Un
// <img> dessus casse silencieusement (icône cassée) ; un <video> affiche
// nativement sa 1re frame comme aperçu, sans lecture ni contrôles.
//
// Survol -> aperçu agrandi. Positionné en `fixed` calculé depuis la position
// réelle de la vignette (getBoundingClientRect) plutôt qu'en `absolute` dans le
// tableau : le tableau défile horizontalement (overflow-x-auto), qui aurait
// coupé un aperçu positionné en absolute dès qu'il dépasse la zone visible.
const AdThumbnail = ({ url, mediaType }) => {
  const [hoverPos, setHoverPos] = useState(null); // {top, left} ou null = masqué
  const triggerRef = useRef(null);

  const showPreview = () => {
    const rect = triggerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const previewSize = 260;
    // À droite de la vignette par défaut ; bascule à gauche si ça déborderait
    // de la fenêtre (cas des colonnes Preview proches du bord droit).
    const left = rect.right + 12 + previewSize > window.innerWidth
      ? rect.left - previewSize - 12
      : rect.right + 12;
    const top = Math.min(Math.max(rect.top - previewSize / 2 + rect.height / 2, 8), window.innerHeight - previewSize - 8);
    setHoverPos({ top, left });
  };

  if (!url) {
    return (
      <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center flex-shrink-0">
        <FontAwesomeIcon icon={faImage} className="text-gray-300 text-sm" />
      </div>
    );
  }

  return (
    <>
      <div ref={triggerRef} onMouseEnter={showPreview} onMouseLeave={() => setHoverPos(null)} className="inline-block cursor-zoom-in">
        {mediaType === "video" ? (
          <video src={url} muted playsInline preload="metadata" className="w-10 h-10 object-cover rounded-lg border border-gray-100 flex-shrink-0 bg-gray-50" />
        ) : (
          <img src={url} alt="" className="w-10 h-10 object-cover rounded-lg border border-gray-100 flex-shrink-0" />
        )}
      </div>
      {hoverPos && (
        <div
          className="fixed z-[100] rounded-xl border border-gray-200 shadow-2xl bg-white p-1.5 pointer-events-none"
          style={{ top: hoverPos.top, left: hoverPos.left, width: 260, height: 260 }}
        >
          {mediaType === "video" ? (
            <video src={url} muted playsInline autoPlay loop className="w-full h-full object-contain rounded-lg" />
          ) : (
            <img src={url} alt="" className="w-full h-full object-contain rounded-lg" />
          )}
        </div>
      )}
    </>
  );
};

// ─── Helpers ─────────────────────────────────────────────────────

// Catégorise n'importe quel statut de régie en "active" | "paused" | "other".
// Insensible à la casse. Couvre les vocabulaires : Meta/Snap (ACTIVE/PAUSED),
// TikTok (ENABLE/DISABLE), Google (ENABLED/PAUSED/REMOVED), LinkedIn (ACTIVE/
// PAUSED/DRAFT/ARCHIVED/CANCELED).
const ACTIVE_SET = ["ACTIVE", "ENABLE", "ENABLED", "RUNNING", "DELIVERING", "LIVE"];
const PAUSED_SET = ["PAUSED", "DISABLE", "DISABLED", "STOPPED"];
const statusCategory = (s) => {
  const u = String(s || "").toUpperCase().trim();
  if (ACTIVE_SET.includes(u)) return "active";
  if (PAUSED_SET.includes(u)) return "paused";
  return "other"; // DRAFT, ARCHIVED, REMOVED, CANCELED, UNKNOWN…
};

const matchesStatus = (itemStatus, filter) => {
  if (filter === "ALL") return true;
  if (filter === "ACTIVE") return statusCategory(itemStatus) === "active";
  if (filter === "PAUSED") return statusCategory(itemStatus) === "paused";
  return false;
};

const isActive     = (s) => statusCategory(s) === "active";
const isToggleable = (s) => statusCategory(s) !== "other";

const getDateRange = (preset) => {
  const end = new Date(), start = new Date();
  // 364 jours, pas 5 ans : l'API TikTok Insights rejette tout écart > 365 jours
  // ("max time span must be less than 365 days") et Meta Insights renvoie 400
  // au-delà de sa propre limite — un vrai "all time" cassait donc les stats
  // (Spend/Impressions/Clicks/CTR) sur ces deux plateformes. 364j reste le plus
  // large intervalle sûr pour les deux.
  if (preset === "alltime") start.setDate(start.getDate() - 364);
  if (preset === "7d")  start.setDate(start.getDate() - 7);
  if (preset === "30d") start.setDate(start.getDate() - 30);
  const fmt = (d) => d.toISOString().split("T")[0];
  return { start: fmt(start), end: fmt(end) };
};

const fmtNum   = (n) => { if (n == null || n === "") return "—"; const x = Number(n); if (isNaN(x)) return "—"; if (x >= 1e6) return `${(x/1e6).toFixed(1)}M`; if (x >= 1e3) return `${(x/1e3).toFixed(1)}K`; return x.toLocaleString(); };
const fmtSpend = (n) => { if (n == null || n === "") return "—"; const x = parseFloat(n); return isNaN(x) ? "—" : `$${x.toFixed(2)}`; };
const fmtCTR   = (n) => { if (n == null || n === "") return "—"; const x = parseFloat(n); return isNaN(x) ? "—" : `${x.toFixed(2)}%`; };

// budgetValue est déjà normalisé en devise réelle par le batch (synced_campaigns),
// plus besoin de logique de conversion par plateforme (cents Meta, micros Snap...).
const fmtBudget = (c) => {
  if (!c.budgetValue) return "—";
  return `$${Number(c.budgetValue).toFixed(0)}${c.isDailyBudget === false ? " life." : "/day"}`;
};

// Lien externe « voir dans le gestionnaire de pub natif » — construit à partir
// des vrais id renvoyés par l'API de chaque régie (jamais de lien inventé sans
// confirmation). Formats confirmés par test réel :
//
// META — Ads Manager utilise une seule page par NIVEAU (campaigns/adsets/ads),
// scopée par compte + business_id, et filtrée par les id sélectionnés (pas de
// page de détail par entité unique) :
//   campagne  → manage/campaigns?act={acc}&business_id={biz}&selected_campaign_ids={id}
//   ad group  → manage/adsets?act={acc}&business_id={biz}&selected_campaign_ids={campaignId}
//   ad        → manage/ads?act={acc}&business_id={biz}&selected_campaign_ids={campaignId}&selected_adset_ids={adsetId}
// business_id vient du champ "business" de l'ad account (Graph API) — absent si
// le compte n'est pas rattaché à un Business Manager, auquel cas on l'omet.
//
// LINKEDIN — 3 onglets Campaign Manager, chacun scopé par compte, avec
// ?businessId=personal requis (valeur confirmée pour un compte géré en direct ;
// peut différer sous Business Manager LinkedIn, non testé) :
//   notre "campaign"  = campaign group LinkedIn → /campaign-groups/{id}
//   notre "ad group"  = campaign LinkedIn       → /campaigns/{id}/details
//   notre "ad"        = creative LinkedIn       → /creatives/{id}
//
// TikTok/Snapchat n'exposent aucun schéma de lien direct vers une entité précise
// dans leur doc publique — on ouvre le gestionnaire scopé sur le bon compte.
// Google Ads : ocid (id obfusqué requis pour un lien garanti) n'est pas exposé
// par l'API ; __u/__c avec le customer id brut est le contournement documenté
// par la communauté (fonctionne dans la grande majorité des cas, sinon Google
// Ads affiche le sélecteur de compte plutôt qu'une erreur).
const linkedInManagerUrl = (accountId, segment, id, suffix = "") =>
  `https://www.linkedin.com/campaignmanager/accounts/${accountId}/${segment}/${id}${suffix}?businessId=personal`;

const metaManagerUrl = (page, params) => {
  const qs = Object.entries(params).filter(([, v]) => v != null && v !== "").map(([k, v]) => `${k}=${v}`).join("&");
  return `https://adsmanager.facebook.com/adsmanager/manage/${page}?${qs}&nav_source=no_referrer`;
};

// Fallback compte — utilisé quand on n'a pas de schéma d'URL confirmé pour une
// entité précise (TikTok/Snapchat/Google à tous niveaux, ainsi que Meta/LinkedIn
// tant que le compte n'est pas encore chargé) : mieux vaut ouvrir le bon compte
// pub que n'afficher aucun lien.
const getAccountExternalUrl = (platform, ctx) => {
  switch (platform) {
    case "meta":
      return ctx.accountId ? metaManagerUrl("campaigns", { act: ctx.accountId, business_id: ctx.businessId }) : null;
    case "tiktok":
      return ctx.accountId ? `https://ads.tiktok.com/i18n/perf/campaign?aadvid=${ctx.accountId}` : null;
    case "snapchat":
      return ctx.accountId ? `https://ads.snapchat.com/${ctx.accountId}/manage` : "https://ads.snapchat.com/";
    case "google":
      if (!ctx.accountId) return null;
      { const c = String(ctx.accountId).replace(/[-\s]/g, ""); return `https://ads.google.com/aw/campaigns?__u=${c}&__c=${c}`; }
    case "linkedin":
      return ctx.linkedInAdAccountId ? `https://www.linkedin.com/campaignmanager/accounts/${ctx.linkedInAdAccountId}/campaigns?businessId=personal` : null;
    default:
      return null;
  }
};

const getCampaignExternalUrl = (platform, campaign, ctx) => {
  const cid = campaign?.id;
  if (!cid) return null;
  switch (platform) {
    case "meta":
      if (!ctx.accountId) return null;
      return metaManagerUrl("campaigns", { act: ctx.accountId, business_id: ctx.businessId, selected_campaign_ids: cid });
    case "linkedin":
      // Format confirmé par test réel : vue liste "campaign-groups" filtrée par
      // campaignGroupIds (tableau JSON encodé), pas de page de détail par id
      // dans le chemin (contrairement à /campaigns/{id} et /creatives/{id}).
      if (!ctx.linkedInAdAccountId) return null;
      return `https://www.linkedin.com/campaignmanager/accounts/${ctx.linkedInAdAccountId}/campaign-groups?businessId=personal&campaignGroupIds=${encodeURIComponent(`[${cid}]`)}`;
    default:
      return getAccountExternalUrl(platform, ctx);
  }
};

// Lien externe niveau ad group. Meta : filtre la page "adsets" par la campagne
// PARENTE (pas d'id propre à l'adset dans l'URL) — nécessite selectedCampaignId.
// Les autres plateformes retombent sur le lien compte (pas de schéma par entité
// confirmé) plutôt que de n'afficher aucun lien.
const getAdGroupExternalUrl = (platform, adGroup, ctx) => {
  if (platform === "linkedin" && ctx.linkedInAdAccountId && adGroup?.id) {
    return linkedInManagerUrl(ctx.linkedInAdAccountId, "campaigns", adGroup.id, "/details");
  }
  if (platform === "meta" && ctx.accountId && ctx.selectedCampaignId) {
    return metaManagerUrl("adsets", { act: ctx.accountId, business_id: ctx.businessId, selected_campaign_ids: ctx.selectedCampaignId });
  }
  return getAccountExternalUrl(platform, ctx);
};

// Lien externe niveau ad (creative). Meta : filtre la page "ads" par campagne +
// adset PARENTS (nécessite selectedCampaignId ET selectedAdGroupId). Les autres
// plateformes retombent sur le lien compte.
const getAdExternalUrl = (platform, ad, ctx) => {
  if (platform === "linkedin" && ctx.linkedInAdAccountId && ad?.id) {
    return linkedInManagerUrl(ctx.linkedInAdAccountId, "creatives", ad.id);
  }
  if (platform === "meta" && ctx.accountId && ctx.selectedCampaignId && ctx.selectedAdGroupId) {
    return metaManagerUrl("ads", {
      act: ctx.accountId, business_id: ctx.businessId,
      selected_campaign_ids: ctx.selectedCampaignId, selected_adset_ids: ctx.selectedAdGroupId,
    });
  }
  return getAccountExternalUrl(platform, ctx);
};

// ─── Main Component ───────────────────────────────────────────────

const CampaignManager = () => {
  const [platform, setPlatform] = useState(null);
  const [platformLoading, setPlatformLoading] = useState(false);
  const [linkedInAdAccountId, setLinkedInAdAccountId] = useState(null);
  // Sélecteur de compte publicitaire (Google / TikTok).
  const [accounts, setAccounts] = useState([]);
  const [accountId, setAccountId] = useState(null);
  const [datePreset, setDatePreset] = useState("alltime");
  const [demoMode, setDemoMode] = useState(false);
  const [demoReason, setDemoReason] = useState("not_connected"); // "not_connected" | "empty"
  // Plateformes connectées (pour griser les onglets non connectés). null = en cours.
  const [connectedSet, setConnectedSet] = useState(null);

  useEffect(() => {
    getRequest("/api/connected-platforms/all")
      .then((res) => {
        const names = Array.isArray(res)
          ? res.map((p) => (p.name || p.platform || "").toLowerCase())
          : Object.entries(res || {}).filter(([, v]) => v).map(([k]) => k.toLowerCase());
        setConnectedSet(new Set(names.filter(Boolean)));
      })
      .catch(() => setConnectedSet(new Set())); // en cas d'échec : ne bloque personne
  }, []);

  // Campaigns
  const [campaigns, setCampaigns] = useState([]);
  const [campaignsLoading, setCampaignsLoading] = useState(false);
  const [campaignSearch, setCampaignSearch] = useState("");
  const [campaignStatusFilter, setCampaignStatusFilter] = useState("ALL");
  const [campaignSort, setCampaignSort] = useState({ key: null, dir: "asc" });
  // Filtre par date de création (indépendant du datePreset au-dessus, qui ne
  // filtre rien — voir CampaignManager: les campagnes sont toujours "all time").
  const [createdFrom, setCreatedFrom] = useState("");
  const [createdTo, setCreatedTo] = useState("");

  // Metrics
  const [metrics, setMetrics] = useState({});
  const [metricsLoading, setMetricsLoading] = useState(false);
  const [togglingId, setTogglingId] = useState(null);

  // Budget editing
  const [editingBudgetId, setEditingBudgetId] = useState(null);
  const [budgetInput, setBudgetInput] = useState("");
  const [savingBudgetId, setSavingBudgetId] = useState(null);

  // Bulk selection
  const [selectedIds, setSelectedIds] = useState([]);
  const [bulkLoading, setBulkLoading] = useState(false);

  // Ad Groups
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [adGroups, setAdGroups] = useState([]);
  const [adGroupsLoading, setAdGroupsLoading] = useState(false);
  const [adGroupSearch, setAdGroupSearch] = useState("");
  const [adGroupStatusFilter, setAdGroupStatusFilter] = useState("ALL");
  const [adGroupSort, setAdGroupSort] = useState({ key: null, dir: "asc" });

  // Ads (3rd level)
  const [selectedAdGroup, setSelectedAdGroup] = useState(null);
  const [ads, setAds] = useState([]);
  const [adsLoading, setAdsLoading] = useState(false);
  const [adSearch, setAdSearch] = useState("");
  const [adStatusFilter, setAdStatusFilter] = useState("ALL");

  const campaignLabel = platform === "linkedin" ? "Campaign Groups" : "Campaigns";
  const adGroupLabel  = platform === "linkedin" ? "Campaigns" : platform === "snapchat" ? "Ad Squads" : "Ad Groups";
  const adLabel       = platform === "linkedin" ? "Creatives" : "Ads";
  const hasInsights   = platform === "tiktok" || platform === "meta";

  const campaignsRef = useRef([]);
  useEffect(() => { campaignsRef.current = campaigns; }, [campaigns]);

  // ── Derived / sorted lists ────────────────────────────────────────

  const handleCampaignSort = (key) =>
    setCampaignSort(prev => prev.key === key ? { key, dir: prev.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" });

  const handleAdGroupSort = (key) =>
    setAdGroupSort(prev => prev.key === key ? { key, dir: prev.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" });

  const filteredCampaigns = useMemo(() => {
    const fromTime = createdFrom ? new Date(createdFrom).getTime() : null;
    // Fin de journée incluse pour la borne "à".
    const toTime = createdTo ? new Date(createdTo).getTime() + 86400000 - 1 : null;
    let list = campaigns.filter(c => {
      if (!c.name.toLowerCase().includes(campaignSearch.toLowerCase())) return false;
      if (!matchesStatus(c.status, campaignStatusFilter)) return false;
      if (fromTime || toTime) {
        // Pas de date connue (ex: LinkedIn/Google si absente) -> exclu dès qu'un
        // filtre de date est actif, plutôt que de fausser silencieusement les résultats.
        if (!c.createdAt) return false;
        const t = new Date(c.createdAt).getTime();
        if (Number.isNaN(t)) return false;
        if (fromTime && t < fromTime) return false;
        if (toTime && t > toTime) return false;
      }
      return true;
    });
    if (!campaignSort.key) return list;
    return [...list].sort((a, b) => {
      let av, bv;
      if (["spend","impressions","clicks","ctr"].includes(campaignSort.key)) {
        av = parseFloat(metrics[a.id]?.[campaignSort.key] || 0);
        bv = parseFloat(metrics[b.id]?.[campaignSort.key] || 0);
      } else if (campaignSort.key === "budget") {
        av = a.budgetValue || 0; bv = b.budgetValue || 0;
      } else {
        av = (a[campaignSort.key] || "").toString().toLowerCase();
        bv = (b[campaignSort.key] || "").toString().toLowerCase();
      }
      return (av < bv ? -1 : av > bv ? 1 : 0) * (campaignSort.dir === "asc" ? 1 : -1);
    });
  }, [campaigns, campaignSearch, campaignStatusFilter, campaignSort, metrics, createdFrom, createdTo]);

  // Compteurs par filtre — affichés sur les onglets ALL / ACTIVE / PAUSED.
  const statusCounts = useMemo(() => ({
    ALL: campaigns.length,
    ACTIVE: campaigns.filter(c => statusCategory(c.status) === "active").length,
    PAUSED: campaigns.filter(c => statusCategory(c.status) === "paused").length,
  }), [campaigns]);

  const filteredAdGroups = useMemo(() => {
    let list = adGroups.filter(g =>
      g.name.toLowerCase().includes(adGroupSearch.toLowerCase()) &&
      matchesStatus(g.status, adGroupStatusFilter)
    );
    if (!adGroupSort.key) return list;
    return [...list].sort((a, b) => {
      const av = (a[adGroupSort.key] || "").toString().toLowerCase();
      const bv = (b[adGroupSort.key] || "").toString().toLowerCase();
      return (av < bv ? -1 : av > bv ? 1 : 0) * (adGroupSort.dir === "asc" ? 1 : -1);
    });
  }, [adGroups, adGroupSearch, adGroupStatusFilter, adGroupSort]);

  const filteredAds = useMemo(() =>
    ads.filter(a => a.name.toLowerCase().includes(adSearch.toLowerCase()) && matchesStatus(a.status, adStatusFilter)),
    [ads, adSearch, adStatusFilter]
  );

  // ── Summary stats (computed from loaded data, no extra API calls) ─

  const summaryStats = useMemo(() => {
    if (!campaigns.length) return null;
    const active  = campaigns.filter(c => isActive(c.status)).length;
    const paused  = campaigns.filter(c => !isActive(c.status) && isToggleable(c.status)).length;
    // Budget total des campagnes ACTIVES uniquement — sommer les 692 budgets
    // de campagnes en pause donnait un chiffre absurde (8,8 M$ constaté) qui
    // ne correspond à aucune dépense réelle.
    const totalBudget = campaigns
      .filter(c => isActive(c.status))
      .reduce((s, c) => s + (c.budgetValue || 0), 0);
    const vals = Object.values(metrics);
    if (!hasInsights || !vals.length) return { active, paused, totalBudget, hasMetrics: false };
    const totalSpend  = vals.reduce((s, m) => s + parseFloat(m.spend || 0), 0);
    const totalImpr   = vals.reduce((s, m) => s + parseInt(m.impressions || 0), 0);
    const totalClicks = vals.reduce((s, m) => s + parseInt(m.clicks || 0), 0);
    const avgCTR      = totalImpr > 0 ? (totalClicks / totalImpr * 100) : 0;
    return { active, paused, totalBudget, totalSpend, totalImpr, totalClicks, avgCTR, hasMetrics: true };
  }, [campaigns, metrics, hasInsights]);

  // ── Bulk selection helpers ────────────────────────────────────────

  const allFilteredSelected =
    filteredCampaigns.length > 0 &&
    filteredCampaigns.every(c => selectedIds.includes(c.id));

  const handleSelectAll = (e) => {
    e.stopPropagation();
    if (allFilteredSelected) {
      setSelectedIds(prev => prev.filter(id => !filteredCampaigns.find(c => c.id === id)));
    } else {
      setSelectedIds(prev => [...new Set([...prev, ...filteredCampaigns.map(c => c.id)])]);
    }
  };

  const handleSelectOne = (id, e) => {
    e.stopPropagation();
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  // ── Core toggle (used by single + bulk) ──────────────────────────

  const toggleCampaignStatus = useCallback(async (campaign) => {
    const curr = isActive(campaign.status);
    let newStatus;
    if (demoMode) {
      await new Promise(r => setTimeout(r, 500));
      if (platform === "tiktok")   return curr ? "DISABLE" : "ENABLE";
      return curr ? "PAUSED" : "ACTIVE";
    }
    if (platform === "tiktok") {
      newStatus = curr ? "DISABLE" : "ENABLE";
      await postRequest(`/api/ads/tiktok/campaign/${campaign.id}/status`, { status: newStatus });
    } else if (platform === "meta") {
      newStatus = curr ? "PAUSED" : "ACTIVE";
      await postRequest(`/api/ads/meta/campaign/${campaign.id}/status`, { status: newStatus });
    } else if (platform === "snapchat") {
      newStatus = curr ? "PAUSED" : "ACTIVE";
      await postRequest(`/api/ads/snapchat/campaign/${campaign.id}/status`, { status: newStatus });
    } else if (platform === "linkedin") {
      newStatus = curr ? "PAUSED" : "ACTIVE";
      await postRequest(`/api/ads/linkedin/ad-accounts/${linkedInAdAccountId}/campaign-groups/${campaign.id}/status`, { status: newStatus });
    } else if (platform === "google") {
      newStatus = curr ? "PAUSED" : "ACTIVE";
      const googleStatus = curr ? "PAUSED" : "ENABLED";
      await postRequest(`/api/ads/google/campaign/${campaign.id}/status`, { status: googleStatus });
    }
    return newStatus;
  }, [platform, linkedInAdAccountId, demoMode]);

  const handleToggleCampaign = async (campaign, e) => {
    e.stopPropagation();
    if (togglingId || !isToggleable(campaign.status)) return;
    setTogglingId(campaign.id);
    try {
      const newStatus = await toggleCampaignStatus(campaign);
      setCampaigns(prev => prev.map(c => c.id === campaign.id ? { ...c, status: newStatus } : c));
      toast.success(demoMode
        ? `[Demo] Campaign ${isActive(campaign.status) ? "paused" : "resumed"} (simulated).`
        : `Campaign ${isActive(campaign.status) ? "paused" : "resumed"}.`
      );
    } catch (err) {
      toast.error(err.message || "Failed to update campaign status.");
    } finally {
      setTogglingId(null);
    }
  };

  // ── Bulk pause / resume ───────────────────────────────────────────

  const handleBulkAction = async (action) => {
    const toProcess = selectedIds
      .map(id => campaigns.find(c => c.id === id))
      .filter(c => c && isToggleable(c.status) && (action === "pause" ? isActive(c.status) : !isActive(c.status)));

    if (!toProcess.length) {
      toast.info(`All selected campaigns are already ${action === "pause" ? "paused" : "active"}.`);
      return;
    }

    setBulkLoading(true);
    const updates = {};
    let count = 0;
    for (const campaign of toProcess) {
      try {
        updates[campaign.id] = await toggleCampaignStatus(campaign);
        count++;
      } catch (err) {
        console.warn(`Bulk ${action} failed for ${campaign.name}:`, err.message);
      }
    }
    setCampaigns(prev => prev.map(c => updates[c.id] ? { ...c, status: updates[c.id] } : c));
    setSelectedIds([]);
    setBulkLoading(false);
    toast.success(`${count} campaign(s) ${action === "pause" ? "paused" : "resumed"}.`);
  };

  // ── Inline budget edit ────────────────────────────────────────────

  const startEditBudget = (campaign, e) => {
    e.stopPropagation();
    const raw = campaign.budgetValue || 0;
    setEditingBudgetId(campaign.id);
    setBudgetInput(String(raw));
  };

  const cancelEditBudget = (e) => {
    e?.stopPropagation();
    setEditingBudgetId(null);
    setBudgetInput("");
  };

  const saveBudget = async (campaign, e) => {
    e?.stopPropagation();
    const val = parseFloat(budgetInput);
    if (isNaN(val) || val <= 0) { toast.error("Enter a valid budget amount."); return; }
    setSavingBudgetId(campaign.id);
    try {
      if (demoMode) {
        await new Promise(r => setTimeout(r, 600));
        setCampaigns(prev => prev.map(c => c.id === campaign.id ? { ...c, budgetValue: val } : c));
        toast.success("[Demo] Budget updated (simulated).");
      } else if (platform === "tiktok") {
        await postRequest(`/api/ads/tiktok/campaign/${campaign.id}/budget`, { budget: val });
        setCampaigns(prev => prev.map(c => c.id === campaign.id ? { ...c, budgetValue: val, isDailyBudget: true } : c));
        toast.success("TikTok budget updated.");
      } else if (platform === "meta") {
        const budgetType = campaign.isDailyBudget === false ? "lifetime" : "daily";
        await postRequest(`/api/ads/meta/campaign/${campaign.id}/budget`, { amount: val, budgetType });
        setCampaigns(prev => prev.map(c => c.id === campaign.id ? { ...c, budgetValue: val, isDailyBudget: budgetType === "daily" } : c));
        toast.success("Meta budget updated.");
      } else if (platform === "snapchat") {
        await postRequest(`/api/ads/snapchat/campaign/${campaign.id}/budget`, { amount: val });
        setCampaigns(prev => prev.map(c => c.id === campaign.id ? { ...c, budgetValue: val, isDailyBudget: true } : c));
        toast.success("Snapchat budget updated.");
      } else {
        toast.info("Budget editing is not supported for this platform.");
      }
    } catch (err) {
      toast.error(err.message || "Failed to update budget.");
    } finally {
      setSavingBudgetId(null);
      setEditingBudgetId(null);
      setBudgetInput("");
    }
  };

  // ── Export CSV ────────────────────────────────────────────────────

  const handleExportCSV = () => {
    const hasObj = platform === "tiktok" || platform === "meta";
    const headers = ["ID", "Name", "Status", "Budget", "Spend", "Impressions", "Clicks", "CTR"];
    if (hasObj) headers.push("Objective");

    const rows = filteredCampaigns.map(c => {
      const m = metrics[c.id] || {};
      const statusLabel = c.status === "ENABLE" ? "ACTIVE" : c.status === "DISABLE" ? "PAUSED" : c.status;
      const row = [
        c.id,
        `"${(c.name || "").replace(/"/g, '""')}"`,
        statusLabel,
        `"${fmtBudget(c)}"`,
        m.spend || "",
        m.impressions || "",
        m.clicks || "",
        m.ctr || "",
      ];
      if (hasObj) row.push(`"${c.objective || ""}"`);
      return row.join(",");
    });

    const csv = [headers.join(","), ...rows].join("\n");
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" }); // BOM for Excel
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `campaigns_${platform}_${datePreset}_${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("CSV exported.");
  };

  // ── Insights ─────────────────────────────────────────────────────

  const loadInsights = useCallback(async (p, campaignList, preset) => {
    if (!["tiktok", "meta"].includes(p) || !campaignList.length) { setMetrics({}); return; }
    setMetricsLoading(true);
    try {
      const { start, end } = getDateRange(preset);
      const ids = campaignList.map(c => c.id).join(",");
      const result = p === "tiktok"
        ? await getRequest(`/api/ads/tiktok/campaign-insights?campaign_ids=${ids}&start_date=${start}&end_date=${end}`)
        : await getRequest(`/api/ads/meta/campaign-insights?campaign_ids=${ids}&start_date=${start}&end_date=${end}`);
      setMetrics(result?.data || {});
    } catch (err) {
      console.warn("Metrics load failed:", err.message);
      setMetrics({});
    } finally {
      setMetricsLoading(false);
    }
  }, []);

  const handleDatePresetChange = (preset) => {
    setDatePreset(preset);
    if (demoMode) {
      // In demo mode keep the same demo insights regardless of date range
      return;
    }
    if (platform && campaignsRef.current.length > 0) loadInsights(platform, campaignsRef.current, preset);
  };

  // ── Load Campaigns ────────────────────────────────────────────────

  const loadCampaigns = useCallback(async (p, liAccId, preset) => {
    setCampaignsLoading(true);
    setCampaigns([]); setSelectedCampaign(null); setAdGroups([]);
    setSelectedAdGroup(null); setAds([]);
    setAdGroupSearch(""); setAdSearch(""); setCampaignStatusFilter("ALL");
    setMetrics([]); setSelectedIds([]);

    try {
      // Lit la BD (table synced_campaigns), alimentée par le batch (syncService,
      // toutes les 5 min) — jamais d'appel direct aux API des régies à chaque
      // chargement de page. daily_budget/lifetime_budget sont déjà normalisés en
      // devise réelle par le batch (plus de conversion cents/micros ici).
      // isCurrent=false -> badge "History" (absent du dernier sync réussi),
      // conservé plutôt que supprimé.
      const result = await getRequest(`/api/sync/campaigns?platform=${p}`);
      const items = (result?.data || []).map(c => ({
        id: c.platform_campaign_id, name: c.name || "—",
        status: (c.status || "UNKNOWN").toUpperCase(),
        objective: c.objective || "",
        budgetValue: c.daily_budget || c.lifetime_budget || 0,
        isDailyBudget: c.daily_budget != null,
        createdAt: c.start_time || c.last_synced_at || null,
        isCurrent: c.is_current !== false,
        lastSyncedAt: c.last_synced_at || null,
      }));
      if (!items || items.length === 0) {
        if (DEMO_DATA.campaigns[p]) {
          setDemoMode(true); setDemoReason("empty");
          setCampaigns(DEMO_DATA.campaigns[p]);
          if (DEMO_DATA.insights[p]) setMetrics(DEMO_DATA.insights[p]);
        } else {
          setCampaigns([]);
        }
      } else {
        setCampaigns(items);
        await loadInsights(p, items, preset);
      }
    } catch (err) {
      if (DEMO_DATA.campaigns[p]) {
        const isNotConnected = /not connected|not found|not configured|no .+ account|no .+ id|no .+ selected|access token|advertiser.?id|expired|invalid.*(token|access)/i.test(err.message);
        setDemoMode(true); setDemoReason(isNotConnected ? "not_connected" : "empty");
        setCampaigns(DEMO_DATA.campaigns[p]);
        if (DEMO_DATA.insights[p]) setMetrics(DEMO_DATA.insights[p]);
        if (!isNotConnected) console.warn("Campaign load failed, showing demo data:", err.message);
      } else {
        toast.error(err.message || "Failed to load campaigns.");
      }
    } finally {
      setCampaignsLoading(false);
    }
  }, [loadInsights]);

  // Charge les comptes d'une plateforme (Google/TikTok), auto-sélectionne un
  // compte par défaut si aucun n'est choisi, et renvoie l'id retenu.
  const loadAccountsAndSelect = useCallback(async (p) => {
    const cfg = ACCOUNT_UI[p];
    setAccounts([]); setAccountId(null);
    if (!cfg) return null;
    try {
      const [list, current] = await Promise.all([cfg.fetchList(getRequest), cfg.current(getRequest)]);
      setAccounts(list);
      let chosen = current && list.some(a => a.id === current && !a.disabled) ? current : null;
      // Auto-sélection par défaut : 1er compte éligible (non gestionnaire).
      if (!chosen) {
        if (cfg.ensureDefault) chosen = await cfg.ensureDefault(postRequest);
        if (!chosen) {
          const first = list.find(a => !a.disabled);
          if (first) { chosen = first.id; try { await cfg.save(postRequest, chosen); } catch {} }
        }
      }
      setAccountId(chosen);
      return chosen;
    } catch { return null; }
  }, []);

  const handleSelectPlatform = async (p) => {
    if (platformLoading) return;
    setPlatform(p);
    setDemoMode(false); setDemoReason("not_connected");
    setCampaignSearch(""); setAdGroupSearch(""); setAdSearch("");
    setCampaignStatusFilter("ALL"); setAdGroupStatusFilter("ALL"); setAdStatusFilter("ALL");
    setCampaignSort({ key: null, dir: "asc" }); setAdGroupSort({ key: null, dir: "asc" });
    setSelectedCampaign(null); setAdGroups([]); setSelectedAdGroup(null); setAds([]);
    setSelectedIds([]); setAccounts([]); setAccountId(null); setLinkedInAdAccountId(null);
    // Toutes les plateformes passent par le sélecteur de compte (liste via API +
    // auto-sélection d'un compte par défaut), puis on charge les campagnes.
    setPlatformLoading(true);
    let chosen = null;
    try { chosen = await loadAccountsAndSelect(p); } finally { setPlatformLoading(false); }
    if (p === "linkedin") {
      if (!chosen) { toast.error("Aucun compte LinkedIn — connectez-le dans « Plateformes »."); return; }
      setLinkedInAdAccountId(chosen);
      await loadCampaigns(p, chosen, datePreset);
    } else {
      // google / tiktok / meta / snapchat : loadCampaigns lit le compte sauvegardé.
      await loadCampaigns(p, null, datePreset);
    }
  };

  // Bascule de compte publicitaire : sauvegarde le choix puis recharge les campagnes.
  const handleSelectAccount = async (id) => {
    const cfg = ACCOUNT_UI[platform];
    if (!cfg || id === accountId) return;
    setAccountId(id);
    setPlatformLoading(true);
    try {
      await cfg.save(postRequest, id);
      // LinkedIn charge les campagnes par compte (param) ; les autres via le compte sauvegardé.
      if (platform === "linkedin") { setLinkedInAdAccountId(id); await loadCampaigns(platform, id, datePreset); }
      else await loadCampaigns(platform, null, datePreset);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Changement de compte impossible.");
    } finally {
      setPlatformLoading(false);
    }
  };

  // ── Campaign → Ad Groups ──────────────────────────────────────────

  const handleSelectCampaign = async (campaign) => {
    if (selectedCampaign?.id === campaign.id) {
      setSelectedCampaign(null); setAdGroups([]); setSelectedAdGroup(null); setAds([]);
      return;
    }
    setSelectedCampaign(campaign); setAdGroupsLoading(true);
    setAdGroups([]); setSelectedAdGroup(null); setAds([]);
    setAdGroupSearch(""); setAdGroupStatusFilter("ALL");

    if (demoMode) {
      await new Promise(r => setTimeout(r, 400));
      setAdGroups(DEMO_DATA.adGroups[platform]?.[campaign.id] || []);
      setAdGroupsLoading(false);
      return;
    }

    const toastId = toast.loading(`Chargement des ${adGroupLabel.toLowerCase()} ${PLATFORMS.find(p => p.key === platform)?.label || platform}...`);
    try {
      // Lit synced_adsets (BD), filtré par campagne — même logique DB-first que
      // loadCampaigns, unifiée pour toutes les plateformes (fini les 5 branches
      // avec 5 endpoints et 5 formats de champs différents).
      const result = await getRequest(`/api/sync/adsets?platform=${platform}&campaign_id=${campaign.id}`);
      const items = (result?.data || []).map(g => ({
        id: g.platform_adset_id, name: g.name || "—",
        status: (g.status || "UNKNOWN").toUpperCase(),
        isCurrent: g.is_current !== false,
      }));
      if (!items || items.length === 0) {
        const demoGroups = DEMO_DATA.adGroups[platform]?.[campaign.id];
        setAdGroups(demoGroups || []);
        toast.update(toastId, { render: `Aucune ${adGroupLabel.toLowerCase()} trouvée.`, type: "info", isLoading: false, autoClose: 2500 });
      } else {
        setAdGroups(items);
        toast.update(toastId, { render: `${items.length} ${adGroupLabel.toLowerCase()} ${PLATFORMS.find(p => p.key === platform)?.label || platform}`, type: "success", isLoading: false, autoClose: 2500 });
      }
    } catch (err) {
      const demoGroups = DEMO_DATA.adGroups[platform]?.[campaign.id] || [];
      setAdGroups(demoGroups);
      if (!demoGroups.length) {
        toast.update(toastId, { render: err.message || `Failed to load ${adGroupLabel.toLowerCase()}.`, type: "error", isLoading: false, autoClose: 3500 });
      } else {
        toast.dismiss(toastId);
      }
    } finally {
      setAdGroupsLoading(false);
    }
  };

  // ── Ad Group → Ads ────────────────────────────────────────────────

  const handleSelectAdGroup = async (adGroup) => {
    if (selectedAdGroup?.id === adGroup.id) { setSelectedAdGroup(null); setAds([]); return; }
    setSelectedAdGroup(adGroup); setAdsLoading(true);
    setAds([]); setAdSearch(""); setAdStatusFilter("ALL");

    if (demoMode) {
      await new Promise(r => setTimeout(r, 350));
      setAds(DEMO_DATA.ads[platform]?.[adGroup.id] || []);
      setAdsLoading(false);
      return;
    }

    const toastId = toast.loading(`Chargement des ${adLabel.toLowerCase()} ${PLATFORMS.find(p => p.key === platform)?.label || platform}...`);
    try {
      // Lit synced_ads (BD), filtré par ad group — thumbnail_url/media_type déjà
      // résolus par le batch (image_ids TikTok, media Snapchat, creative Meta...).
      const result = await getRequest(`/api/sync/ads?platform=${platform}&adset_id=${adGroup.id}`);
      const items = (result?.data || []).map(a => ({
        id: a.platform_ad_id, name: a.name || "—",
        status: (a.status || "UNKNOWN").toUpperCase(),
        thumbnailUrl: a.thumbnail_url || null,
        mediaType: a.media_type || "image",
        isCurrent: a.is_current !== false,
      }));
      if (!items.length) {
        setAds(DEMO_DATA.ads[platform]?.[adGroup.id] || []);
        toast.update(toastId, { render: `Aucune ${adLabel.toLowerCase()} trouvée.`, type: "info", isLoading: false, autoClose: 2500 });
      } else {
        setAds(items);
        toast.update(toastId, { render: `${items.length} ${adLabel.toLowerCase()} ${PLATFORMS.find(p => p.key === platform)?.label || platform}`, type: "success", isLoading: false, autoClose: 2500 });
      }
    } catch (err) {
      const demoAds = DEMO_DATA.ads[platform]?.[adGroup.id] || [];
      setAds(demoAds);
      if (!demoAds.length) {
        toast.update(toastId, { render: err.message || `Failed to load ${adLabel.toLowerCase()}.`, type: "error", isLoading: false, autoClose: 3500 });
      } else {
        toast.dismiss(toastId);
      }
    } finally {
      setAdsLoading(false);
    }
  };

  // ─── Render ───────────────────────────────────────────────────────

  return (
    <div className="p-6 space-y-6">
      {/* Page Header */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
          <FontAwesomeIcon icon={faBullhorn} className="text-[#221C51]" />
          Campaign Manager
        </h2>
        <p className="text-sm text-gray-500 mt-1">Browse and manage campaigns across all your connected platforms</p>
        <hr className="border-t border-gray-200 mt-3" />
      </div>

      {/* Platform tabs + Date picker */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex gap-2 flex-wrap">
          {PLATFORMS.map(p => {
            const isAct = platform === p.key;
            // Grisé si la plateforme n'est pas connectée (connectedSet chargé).
            const notConnected = connectedSet !== null && !connectedSet.has(p.key);
            return (
              <button key={p.key} onClick={() => handleSelectPlatform(p.key)} disabled={platformLoading}
                title={notConnected ? `${p.label} non connecté — cliquez pour connecter` : p.label}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 ${
                  isAct ? "bg-[#221C51] text-white shadow-md"
                  : notConnected ? "bg-gray-100 border border-gray-200 text-gray-400 hover:text-gray-500 hover:border-gray-300"
                  : "bg-white border border-gray-200 text-gray-600 hover:border-[#221C51]/40 hover:shadow-sm"
                }`}>
                {p.icon
                  ? <FontAwesomeIcon icon={p.icon} className={isAct ? "text-white" : notConnected ? "text-gray-300" : p.iconColor} />
                  : <span className={`text-base leading-none ${notConnected ? "opacity-40 grayscale" : ""}`}>{p.emoji}</span>
                }
                {p.label}
                {notConnected && <span className="w-1.5 h-1.5 rounded-full bg-gray-300" title="non connecté" />}
                {isAct && (campaignsLoading || platformLoading) && <FontAwesomeIcon icon={faSpinner} spin className="text-xs ml-1 opacity-70" />}
              </button>
            );
          })}
        </div>
        <div className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-xl p-1">
          <FontAwesomeIcon icon={faCalendarAlt} className="text-gray-400 text-xs ml-1.5" />
          {DATE_PRESETS.map(dp => (
            <button key={dp.key} onClick={() => handleDatePresetChange(dp.key)}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                datePreset === dp.key ? "bg-[#221C51] text-white shadow-sm" : "text-gray-500 hover:text-gray-700 hover:bg-gray-100"
              }`}>
              {dp.label}
            </button>
          ))}
        </div>
      </div>

      {/* No Platform */}
      {!platform && (
        <div className="flex flex-col items-center justify-center py-24 text-gray-300">
          <FontAwesomeIcon icon={faLayerGroup} className="text-6xl mb-5" />
          <p className="text-base font-medium text-gray-400">Select a platform above to browse campaigns</p>
        </div>
      )}

      {/* Demo Mode Banner */}
      {demoMode && platform && (
        <div className="flex items-center gap-3 px-5 py-3 rounded-xl border border-amber-200 bg-amber-50 text-amber-800 text-sm">
          <span className="text-lg">🎭</span>
          <div className="flex-1">
            <span className="font-semibold">Demo Mode — </span>
            <span className="text-amber-700">
              {demoReason === "empty"
                ? `${platform.charAt(0).toUpperCase() + platform.slice(1)} account has no campaigns yet. Showing sample data.`
                : `${platform.charAt(0).toUpperCase() + platform.slice(1)} is not connected. Showing sample data so you can explore the UI.`
              }
            </span>
          </div>
          <span className="text-xs font-medium bg-amber-100 border border-amber-200 px-2.5 py-1 rounded-lg">
            {demoReason === "empty" ? "Create your first campaign to see real data" : "Connect in Platform Settings to see real campaigns"}
          </span>
        </div>
      )}

      {/* ── Breadcrumb — un seul niveau affiché à la fois (campagne OU ad
          group OU ads), pas d'empilement qui force à tout dérouler/scroller ── */}
      {platform && selectedCampaign && (
        <div className="flex items-center gap-2 text-sm">
          <button onClick={() => { setSelectedCampaign(null); setAdGroups([]); setSelectedAdGroup(null); setAds([]); }}
            className="text-gray-500 hover:text-[#221C51] font-medium flex items-center gap-1.5">
            <FontAwesomeIcon icon={faChevronRight} className="rotate-180 text-xs" />
            {campaignLabel}
          </button>
          <span className="text-gray-300">/</span>
          {selectedAdGroup ? (
            <>
              <button onClick={() => { setSelectedAdGroup(null); setAds([]); }}
                className="text-gray-500 hover:text-[#221C51] font-medium truncate max-w-[220px]">
                {selectedCampaign.name}
              </button>
              <span className="text-gray-300">/</span>
              <span className="text-[#221C51] font-semibold truncate max-w-[220px]">{selectedAdGroup.name}</span>
            </>
          ) : (
            <span className="text-[#221C51] font-semibold truncate max-w-[280px]">{selectedCampaign.name}</span>
          )}
        </div>
      )}

      {/* ── Campaigns Panel ── */}
      {platform && !selectedCampaign && (
        <div className="rounded-2xl border border-gray-200 overflow-hidden shadow-sm">

          {/* Panel Header */}
          <div className="flex items-center justify-between px-6 py-4 bg-[#221C51]">
            <div className="flex items-center gap-3">
              <span className="font-semibold text-sm text-white uppercase tracking-wide">{campaignLabel}</span>
              {!campaignsLoading && (
                <span className="bg-white/20 text-white text-xs px-2.5 py-0.5 rounded-full font-medium">
                  {filteredCampaigns.length} / {campaigns.length}
                </span>
              )}
              {/* Sélecteur de compte publicitaire (Google / TikTok) */}
              {ACCOUNT_UI[platform] && accounts.length > 0 && (
                <div className="flex items-center gap-1.5">
                  <span className="text-white/50 text-xs">Compte</span>
                  <select
                    value={accountId || ""}
                    onChange={e => handleSelectAccount(e.target.value)}
                    disabled={platformLoading}
                    className="bg-white/10 text-white text-xs rounded-lg px-2 py-1 border border-white/20 focus:outline-none focus:border-white/50 max-w-[240px] disabled:opacity-50"
                  >
                    {accounts.map(a => (
                      <option key={a.id} value={a.id} disabled={a.disabled} className="text-[#221C51]">
                        {a.label}{a.disabled ? " (gestionnaire)" : ""}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            <div className="flex items-center gap-2">
              {/* Export CSV */}
              {!campaignsLoading && campaigns.length > 0 && (
                <button onClick={handleExportCSV}
                  title="Export current view as CSV"
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-white/10 text-white text-xs rounded-lg hover:bg-white/20 border border-white/20 transition-colors">
                  <FontAwesomeIcon icon={faFileArrowDown} className="text-xs" />
                  CSV
                </button>
              )}
              <div className="flex gap-1">
                {STATUS_FILTERS.map(s => {
                  const on = campaignStatusFilter === s;
                  const count = statusCounts[s] ?? 0;
                  return (
                    <button key={s} onClick={() => { setCampaignStatusFilter(s); setSelectedIds([]); }}
                      className={`flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-medium transition-colors ${
                        on ? "bg-white text-[#221C51]" : "bg-white/10 text-white hover:bg-white/20"
                      }`}>
                      <span>{s === "ALL" ? "Toutes" : s === "ACTIVE" ? "Actives" : "En pause"}</span>
                      <span className={`px-1.5 rounded-full text-[10px] font-bold ${on ? "bg-[#221C51]/10 text-[#221C51]" : "bg-white/20"}`}>{count}</span>
                    </button>
                  );
                })}
              </div>
              <SearchInput value={campaignSearch} onChange={v => { setCampaignSearch(v); setSelectedIds([]); }} placeholder={`Search ${campaignLabel.toLowerCase()}...`} />
              <div className="flex items-center gap-1.5" title="Filtrer par date de création (Google : date de démarrage, pas de vraie date de création côté API)">
                <input type="date" value={createdFrom} onChange={e => { setCreatedFrom(e.target.value); setSelectedIds([]); }}
                  className="bg-white/10 text-white text-xs rounded-lg px-2 py-1 border border-white/20 focus:outline-none focus:border-white/50 [color-scheme:dark]" />
                <span className="text-white/50 text-xs">→</span>
                <input type="date" value={createdTo} onChange={e => { setCreatedTo(e.target.value); setSelectedIds([]); }}
                  className="bg-white/10 text-white text-xs rounded-lg px-2 py-1 border border-white/20 focus:outline-none focus:border-white/50 [color-scheme:dark]" />
                {(createdFrom || createdTo) && (
                  <button onClick={() => { setCreatedFrom(""); setCreatedTo(""); }} title="Effacer le filtre de dates"
                    className="text-white/50 hover:text-white text-xs px-1.5 py-1 rounded-lg hover:bg-white/10">✕</button>
                )}
              </div>
            </div>
          </div>

          {/* Summary Stats Bar */}
          {summaryStats && !campaignsLoading && (
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 px-6 py-3 bg-gray-50 border-b border-gray-100">
              <SummaryStat label="Active"  value={summaryStats.active}  color="text-green-600" />
              <SummaryStat label="Paused"  value={summaryStats.paused}  color="text-amber-600" />
              {summaryStats.totalBudget > 0 && (
                <SummaryStat label="Budget (actives)" value={`$${summaryStats.totalBudget.toFixed(0)}`} />
              )}
              {summaryStats.hasMetrics && <>
                <div className="w-px h-6 bg-gray-200 mx-1" />
                <SummaryStat label="Spend"       value={fmtSpend(summaryStats.totalSpend)}     loading={metricsLoading} />
                <SummaryStat label="Impressions" value={fmtNum(summaryStats.totalImpr)}        loading={metricsLoading} />
                <SummaryStat label="Clicks"      value={fmtNum(summaryStats.totalClicks)}      loading={metricsLoading} />
                <SummaryStat label="Avg CTR"     value={fmtCTR(summaryStats.avgCTR)}           loading={metricsLoading} />
              </>}
            </div>
          )}

          {/* Bulk Action Bar */}
          {selectedIds.length > 0 && (
            <div className="flex items-center gap-3 px-6 py-2.5 bg-[#221C51]/[0.05] border-b border-[#221C51]/10">
              <FontAwesomeIcon icon={faCircleCheck} className="text-[#221C51] text-sm" />
              <span className="text-xs font-semibold text-[#221C51]">{selectedIds.length} selected</span>
              <div className="flex gap-2 ml-auto">
                <button onClick={() => handleBulkAction("pause")} disabled={bulkLoading}
                  className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold bg-amber-500 text-white rounded-lg hover:bg-amber-600 disabled:opacity-50 transition-colors">
                  <FontAwesomeIcon icon={bulkLoading ? faSpinner : faPause} spin={bulkLoading} className="text-xs" />
                  Pause Selected
                </button>
                <button onClick={() => handleBulkAction("resume")} disabled={bulkLoading}
                  className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 transition-colors">
                  <FontAwesomeIcon icon={bulkLoading ? faSpinner : faPlay} spin={bulkLoading} className="text-xs" />
                  Resume Selected
                </button>
                <button onClick={() => setSelectedIds([])} disabled={bulkLoading}
                  className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium bg-white border border-gray-200 text-gray-600 rounded-lg hover:bg-gray-50 disabled:opacity-50 transition-colors">
                  <FontAwesomeIcon icon={faXmark} className="text-xs" />
                  Clear
                </button>
              </div>
            </div>
          )}

          {/* Table */}
          {campaignsLoading ? (
            <div className="flex items-center justify-center py-16 gap-3 bg-white text-gray-400">
              <FontAwesomeIcon icon={faSpinner} spin className="text-2xl text-[#221C51]" />
              <span className="text-sm">Loading {campaignLabel.toLowerCase()}...</span>
            </div>
          ) : filteredCampaigns.length === 0 ? (
            <div className="text-center py-14 bg-white text-gray-400 text-sm">
              {campaigns.length === 0 ? `No ${campaignLabel.toLowerCase()} found` : "No results match your filter"}
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white">
                <thead>
                  <tr className="text-xs text-white/70 uppercase tracking-wider border-b border-[#221C51]/20 bg-[#221C51]/90">
                    {/* Select-all checkbox */}
                    <th className="px-4 py-3 w-10 text-center">
                      <input
                        type="checkbox"
                        checked={allFilteredSelected}
                        onChange={handleSelectAll}
                        onClick={e => e.stopPropagation()}
                        className="w-3.5 h-3.5 rounded accent-white cursor-pointer"
                        title="Select all"
                      />
                    </th>
                    {/* Toggle à gauche */}
                    <th className="px-4 py-3 text-center font-medium text-xs text-white/70 uppercase tracking-wider w-16">Toggle</th>
                    <th className="px-4 py-3 w-8" />
                    <SortableHeader label="Name"   sortKey="name"   sortConfig={campaignSort} onSort={handleCampaignSort} className="text-left" />
                    <th className="px-2 py-3 w-8" title="Lien externe" />
                    <SortableHeader label="Status" sortKey="status" sortConfig={campaignSort} onSort={handleCampaignSort} className="text-left" />
                    <SortableHeader label="Budget" sortKey="budget" sortConfig={campaignSort} onSort={handleCampaignSort} className="text-left" />
                    {hasInsights && <>
                      <SortableHeader label="Spend"  sortKey="spend"       sortConfig={campaignSort} onSort={handleCampaignSort} className="text-right" />
                      <SortableHeader label="Impr."  sortKey="impressions" sortConfig={campaignSort} onSort={handleCampaignSort} className="text-right" />
                      <SortableHeader label="Clicks" sortKey="clicks"      sortConfig={campaignSort} onSort={handleCampaignSort} className="text-right" />
                      <SortableHeader label="CTR"    sortKey="ctr"         sortConfig={campaignSort} onSort={handleCampaignSort} className="text-right" />
                    </>}
                    {(platform === "tiktok" || platform === "meta") && (
                      <th className="px-4 py-3 text-left font-medium text-xs text-white/70 uppercase tracking-wider">Objective</th>
                    )}
                    <th className="px-4 py-3 text-left font-medium text-xs text-white/70 uppercase tracking-wider">{adGroupLabel}</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                  {filteredCampaigns.map(c => {
                    const isSelected   = selectedCampaign?.id === c.id;
                    const isChecked    = selectedIds.includes(c.id);
                    const m            = metrics[c.id];
                    const isToggling   = togglingId === c.id;
                    return (
                      <tr key={c.id} onClick={() => handleSelectCampaign(c)}
                        className={`cursor-pointer transition-all ${
                          isChecked ? "bg-[#221C51]/[0.04]" : ""
                        } ${
                          isSelected ? "border-l-4 border-l-[#221C51]" : "border-l-4 border-l-transparent hover:bg-gray-50/80"
                        }`}>
                        {/* Row checkbox */}
                        <td className="px-4 py-4 text-center w-10" onClick={e => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={e => handleSelectOne(c.id, e)}
                            className="w-3.5 h-3.5 rounded accent-[#221C51] cursor-pointer"
                          />
                        </td>
                        {/* Toggle (déplacé à gauche) */}
                        <td className="px-4 py-4 text-center w-16" onClick={e => e.stopPropagation()}>
                          {isToggleable(c.status) ? (
                            <button
                              role="switch"
                              aria-checked={isActive(c.status)}
                              onClick={e => handleToggleCampaign(c, e)}
                              disabled={!!togglingId}
                              title={isActive(c.status) ? "Mettre en pause" : "Activer"}
                              className={`relative w-11 h-6 rounded-full transition-colors mx-auto disabled:opacity-50 ${
                                isActive(c.status) ? "bg-green-500" : "bg-gray-300"
                              }`}>
                              <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow flex items-center justify-center transition-transform ${
                                isActive(c.status) ? "translate-x-5" : ""
                              }`}>
                                {isToggling && <FontAwesomeIcon icon={faSpinner} spin className="text-[9px] text-gray-400" />}
                              </span>
                            </button>
                          ) : (
                            <span className="text-gray-300 text-xs" title={`Statut « ${String(c.status || "").toUpperCase()} » — non modifiable`}>—</span>
                          )}
                        </td>
                        <td className="px-4 py-4 text-gray-400 w-8">
                          <FontAwesomeIcon icon={isSelected ? faChevronDown : faChevronRight} className="text-xs" />
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-800 max-w-[180px]">
                          <span className="block truncate" title={c.name}>{c.name}</span>
                        </td>
                        <td className="px-2 py-4 text-center" onClick={e => e.stopPropagation()}>
                          {(() => {
                            const url = getCampaignExternalUrl(platform, c, { accountId, linkedInAdAccountId, businessId: accounts.find(acc => acc.id === accountId)?.businessId });
                            return url ? (
                              <a href={url} target="_blank" rel="noopener noreferrer"
                                title={`Voir dans ${PLATFORMS.find(p => p.key === platform)?.label || "le gestionnaire"}`}
                                className="inline-flex items-center justify-center w-6 h-6 rounded text-gray-400 hover:text-[#221C51] hover:bg-gray-100 transition-colors">
                                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" />
                              </a>
                            ) : null;
                          })()}
                        </td>
                        <td className="px-4 py-4"><div className="flex items-center gap-1.5"><StatusBadge status={c.status} />{!c.isCurrent && <HistoryBadge />}</div></td>
                        <td className="px-4 py-4 text-xs text-gray-500 whitespace-nowrap" onClick={e => e.stopPropagation()}>
                          {editingBudgetId === c.id ? (
                            <div className="flex items-center gap-1">
                              <span className="text-gray-400">$</span>
                              <input
                                type="number"
                                min="1"
                                step="1"
                                value={budgetInput}
                                onChange={e => setBudgetInput(e.target.value)}
                                onKeyDown={e => { if (e.key === 'Enter') saveBudget(c, e); if (e.key === 'Escape') cancelEditBudget(e); }}
                                autoFocus
                                className="w-20 px-1.5 py-1 text-xs border border-[#221C51]/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#221C51]/20"
                              />
                              <button onClick={e => saveBudget(c, e)} disabled={!!savingBudgetId} title="Save"
                                className="w-6 h-6 flex items-center justify-center rounded-md bg-green-100 text-green-600 hover:bg-green-200 disabled:opacity-40">
                                <FontAwesomeIcon icon={savingBudgetId === c.id ? faSpinner : faCheck} spin={savingBudgetId === c.id} className="text-xs" />
                              </button>
                              <button onClick={cancelEditBudget} title="Cancel"
                                className="w-6 h-6 flex items-center justify-center rounded-md bg-gray-100 text-gray-500 hover:bg-gray-200">
                                <FontAwesomeIcon icon={faXmark} className="text-xs" />
                              </button>
                            </div>
                          ) : (
                            <div className="flex items-center gap-1.5 group">
                              <span>{fmtBudget(c)}</span>
                              {platform !== 'linkedin' && platform !== 'google' && (
                                <button onClick={e => startEditBudget(c, e)} title="Edit budget"
                                  className="opacity-0 group-hover:opacity-100 transition-opacity w-5 h-5 flex items-center justify-center rounded text-gray-400 hover:text-[#221C51] hover:bg-gray-100">
                                  <FontAwesomeIcon icon={faPencil} className="text-[10px]" />
                                </button>
                              )}
                            </div>
                          )}
                        </td>
                        {hasInsights && <>
                          <td className="px-4 py-4 text-right"><MetricCell value={fmtSpend(m?.spend)}     loading={metricsLoading} /></td>
                          <td className="px-4 py-4 text-right"><MetricCell value={fmtNum(m?.impressions)} loading={metricsLoading} /></td>
                          <td className="px-4 py-4 text-right"><MetricCell value={fmtNum(m?.clicks)}      loading={metricsLoading} /></td>
                          <td className="px-4 py-4 text-right"><MetricCell value={fmtCTR(m?.ctr)}         loading={metricsLoading} /></td>
                        </>}
                        {(platform === "tiktok" || platform === "meta") && (
                          <td className="px-4 py-4 text-xs text-gray-400">{c.objective || "—"}</td>
                        )}
                        <td className="px-4 py-4">
                          <span className={`text-xs font-semibold ${isSelected ? "text-[#221C51]" : "text-gray-400"}`}>
                            {isSelected ? "Showing ▾" : "View →"}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                  {/* État vide : le filtre courant ne renvoie aucune campagne */}
                  {filteredCampaigns.length === 0 && campaigns.length > 0 && (
                    <tr>
                      <td colSpan={20} className="px-4 py-10 text-center text-sm text-gray-400">
                        Aucune campagne {campaignStatusFilter === "ACTIVE" ? "active" : campaignStatusFilter === "PAUSED" ? "en pause" : ""}
                        {campaignSearch ? ` pour « ${campaignSearch} »` : ""}.
                        {campaignStatusFilter !== "ALL" && (
                          <button onClick={() => setCampaignStatusFilter("ALL")} className="ml-2 text-[#221C51] font-semibold hover:underline">
                            Voir toutes
                          </button>
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ── Ad Groups Panel — remplace le niveau campagnes tant qu'aucun ad
          group n'est sélectionné (masqué à son tour dès qu'on descend plus loin) ── */}
      {selectedCampaign !== null && selectedAdGroup === null && (
        <div className="rounded-2xl border border-[#221C51]/20 overflow-hidden shadow-sm">
          <div className="flex items-center justify-between px-6 py-4 bg-[#221C51]/[0.06]">
            <div className="flex items-center gap-3">
              <span className="font-semibold text-sm text-[#221C51] uppercase tracking-wide">{adGroupLabel}</span>
              {selectedCampaign && (
                <span className="text-xs text-gray-500">— <span className="font-medium text-gray-700">{selectedCampaign.name}</span></span>
              )}
              {!adGroupsLoading && (
                <span className="bg-[#221C51] text-white text-xs px-2.5 py-0.5 rounded-full font-medium">{filteredAdGroups.length}</span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <div className="flex gap-1">
                {STATUS_FILTERS.map(s => (
                  <button key={s} onClick={() => setAdGroupStatusFilter(s)}
                    className={`px-3 py-1 rounded-lg text-xs font-medium transition-colors ${
                      adGroupStatusFilter === s ? "bg-[#221C51] text-white" : "bg-white border border-gray-200 text-gray-600 hover:bg-gray-50"
                    }`}>
                    {STATUS_FILTER_LABEL[s]}
                  </button>
                ))}
              </div>
              <SearchInput value={adGroupSearch} onChange={setAdGroupSearch} placeholder={`Search ${adGroupLabel.toLowerCase()}...`} light />
            </div>
          </div>
          {adGroupsLoading ? (
            <div className="flex items-center justify-center py-12 gap-3 bg-white text-gray-400">
              <FontAwesomeIcon icon={faSpinner} spin className="text-xl text-[#221C51]" />
              <span className="text-sm">Loading {adGroupLabel.toLowerCase()}...</span>
            </div>
          ) : filteredAdGroups.length === 0 ? (
            <div className="text-center py-10 bg-white text-gray-400 text-sm">No {adGroupLabel.toLowerCase()} found</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white">
                <thead>
                  <tr className="text-xs text-gray-400 uppercase tracking-wider border-b border-gray-100 bg-gray-50/80">
                    <th className="px-4 py-3 w-8" />
                    <SortableHeaderLight label="Name"   sortKey="name"   sortConfig={adGroupSort} onSort={handleAdGroupSort} className="text-left" />
                    <th className="px-2 py-3 w-8" title="Lien externe" />
                    <SortableHeaderLight label="Status" sortKey="status" sortConfig={adGroupSort} onSort={handleAdGroupSort} className="text-left" />
                    <th className="px-4 py-3 text-left font-medium">ID</th>
                    <th className="px-4 py-3 text-left font-medium">{adLabel}</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                  {filteredAdGroups.map(g => {
                    const isAdGroupSelected = selectedAdGroup?.id === g.id;
                    return (
                      <tr key={g.id} onClick={() => handleSelectAdGroup(g)}
                        className={`cursor-pointer transition-all ${
                          isAdGroupSelected ? "bg-[#221C51]/5 border-l-4 border-l-[#221C51]" : "hover:bg-gray-50/80 border-l-4 border-l-transparent"
                        }`}>
                        <td className="px-4 py-4 text-gray-400 w-8">
                          <FontAwesomeIcon icon={isAdGroupSelected ? faChevronDown : faChevronRight} className="text-xs" />
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-800 max-w-[260px]">
                          <span className="block truncate" title={g.name}>{g.name}</span>
                        </td>
                        <td className="px-2 py-4 text-center" onClick={e => e.stopPropagation()}>
                          {(() => {
                            const url = getAdGroupExternalUrl(platform, g, {
                              linkedInAdAccountId, accountId,
                              businessId: accounts.find(acc => acc.id === accountId)?.businessId,
                              selectedCampaignId: selectedCampaign?.id,
                            });
                            return url ? (
                              <a href={url} target="_blank" rel="noopener noreferrer"
                                title={`Voir dans ${PLATFORMS.find(p => p.key === platform)?.label || "le gestionnaire"}`}
                                className="inline-flex items-center justify-center w-6 h-6 rounded text-gray-400 hover:text-[#221C51] hover:bg-gray-100 transition-colors">
                                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" />
                              </a>
                            ) : null;
                          })()}
                        </td>
                        <td className="px-4 py-4"><div className="flex items-center gap-1.5"><StatusBadge status={g.status} />{!g.isCurrent && <HistoryBadge />}</div></td>
                        <td className="px-4 py-4 text-xs text-gray-400 font-mono">{g.id}</td>
                        <td className="px-4 py-4">
                          <span className={`text-xs font-semibold ${isAdGroupSelected ? "text-[#221C51]" : "text-gray-400"}`}>
                            {isAdGroupSelected ? "Showing ▾" : "View →"}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ── Ads Panel (3rd level) — remplace le niveau ad groups ── */}
      {selectedAdGroup !== null && (
        <div className="rounded-2xl border border-gray-200/80 overflow-hidden shadow-sm">
          <div className="flex items-center justify-between px-6 py-4 bg-gray-50 border-b border-gray-200">
            <div className="flex items-center gap-3">
              <FontAwesomeIcon icon={faRectangleAd} className="text-[#221C51]/60 text-sm" />
              <span className="font-semibold text-sm text-gray-700 uppercase tracking-wide">{adLabel}</span>
              {selectedAdGroup && (
                <span className="text-xs text-gray-500">— <span className="font-medium text-gray-700">{selectedAdGroup.name}</span></span>
              )}
              {!adsLoading && (
                <span className="bg-gray-200 text-gray-600 text-xs px-2.5 py-0.5 rounded-full font-medium">{filteredAds.length}</span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <div className="flex gap-1">
                {STATUS_FILTERS.map(s => (
                  <button key={s} onClick={() => setAdStatusFilter(s)}
                    className={`px-3 py-1 rounded-lg text-xs font-medium transition-colors ${
                      adStatusFilter === s ? "bg-[#221C51] text-white" : "bg-white border border-gray-200 text-gray-600 hover:bg-gray-50"
                    }`}>
                    {STATUS_FILTER_LABEL[s]}
                  </button>
                ))}
              </div>
              <SearchInput value={adSearch} onChange={setAdSearch} placeholder={`Search ${adLabel.toLowerCase()}...`} light />
            </div>
          </div>
          {adsLoading ? (
            <div className="flex items-center justify-center py-10 gap-3 bg-white text-gray-400">
              <FontAwesomeIcon icon={faSpinner} spin className="text-xl text-[#221C51]" />
              <span className="text-sm">Loading {adLabel.toLowerCase()}...</span>
            </div>
          ) : filteredAds.length === 0 ? (
            <div className="text-center py-9 bg-white text-gray-400 text-sm">No {adLabel.toLowerCase()} found</div>
          ) : (
            <div className="overflow-x-auto">
            <table className="min-w-full bg-white">
              <thead>
                <tr className="text-xs text-gray-400 uppercase tracking-wider border-b border-gray-100 bg-gray-50/60">
                  <th className="px-5 py-3 text-left font-medium w-14">Preview</th>
                  <th className="px-5 py-3 text-left font-medium">Name</th>
                  <th className="px-2 py-3 w-8" title="Lien externe" />
                  <th className="px-5 py-3 text-left font-medium">Status</th>
                  {(platform === "tiktok" || platform === "snapchat") && (
                    <th className="px-5 py-3 text-left font-medium">Format / Type</th>
                  )}
                  <th className="px-5 py-3 text-left font-medium">ID</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {filteredAds.map(a => (
                  <tr key={a.id} className="hover:bg-gray-50/60 transition-colors">
                    <td className="px-5 py-3"><AdThumbnail url={a.thumbnailUrl} mediaType={a.mediaType} /></td>
                    <td className="px-5 py-4 text-sm font-medium text-gray-800 max-w-[280px]">
                      <span className="block truncate" title={a.name}>{a.name}</span>
                    </td>
                    <td className="px-2 py-4 text-center">
                      {(() => {
                        const url = getAdExternalUrl(platform, a, {
                          linkedInAdAccountId, accountId,
                          businessId: accounts.find(acc => acc.id === accountId)?.businessId,
                          selectedCampaignId: selectedCampaign?.id,
                          selectedAdGroupId: selectedAdGroup?.id,
                        });
                        return url ? (
                          <a href={url} target="_blank" rel="noopener noreferrer"
                            title={`Voir dans ${PLATFORMS.find(p => p.key === platform)?.label || "le gestionnaire"}`}
                            className="inline-flex items-center justify-center w-6 h-6 rounded text-gray-400 hover:text-[#221C51] hover:bg-gray-100 transition-colors">
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-xs" />
                          </a>
                        ) : null;
                      })()}
                    </td>
                    <td className="px-5 py-4"><div className="flex items-center gap-1.5"><StatusBadge status={a.status} />{!a.isCurrent && <HistoryBadge />}</div></td>
                    {(platform === "tiktok" || platform === "snapchat") && (
                      <td className="px-5 py-4 text-xs text-gray-400">{a.format || a.type || "—"}</td>
                    )}
                    <td className="px-5 py-4 text-xs text-gray-400 font-mono">{a.id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CampaignManager;
